import { deepClone } from "../../../../../helpers/DeepCloneObject";
import { get_ad_accounts, get_campaigns } from "../../../services/api/MetaApi";
import dummyGetAdAccounts from '../data/dummyGetAdAccounts.json';
import apiErrors from '../data/api-errors';
import { ad, campaign } from "google-ads-api/build/src/protos/autogen/resourceNames";
import { save_date_format } from "./SliderCallbackFunctions";

export const add_source = async (creator, setCreator, source, type, accessedAccounts) => {

    const metaAccessToken = accessedAccounts?.meta?.accessToken;
    const metaUserId = accessedAccounts?.meta?.userID;
    const metaUsername = accessedAccounts?.meta?.username;

    let metaHelper = deepClone(creator.metaHelper);
    let reportSections = deepClone(creator.report.sections);
    const fetchedAdAccounts = deepClone(creator.metaHelper?.adAccounts)

    var fetchedAdAccountsError = false;

    switch (type){
        case ("business"): {

            /* Assign selected business */
            metaHelper.selectedBusiness = source;
            
            /* Set the selected business (prevent freezing if we are about to fetch ad Accounts) */
            setCreator((prev) => ({ 
                ...prev, 
                metaHelper
            }))

            /* Check if we have already fetched adAccounts for this business by searching ad account parentBusiness ids */
            if ( !fetchedAdAccounts.some((adAccount) => adAccount.parentBusiness?.id === source?.id) ) {
                const businessId = source?.id;
                setCreator((prev) => ({
                    ...prev,
                    loaders: {
                        ...prev.loaders,
                        adAccounts: false
                    }
                }));
                const fetchAdAccountsReposne = await get_ad_accounts(businessId, metaAccessToken);
   
                /* Fetch adAccoutns for this business */
                let fetchedAdAccounts = fetchAdAccountsReposne?.data?.data?.myAdAccounts;
                /* Check for errors */
                // fetchedAdAccountsError = apiErrors(fetchAdAccountsReposne, creator.t);

 
                // if ( fetchedAdAccountsError ) break;

                /* Assign business to the new parentBusiness property of all fetched AdAccounts */
                const newAdAccounts = fetchedAdAccounts?.map((adAccount) => {
                    return {...adAccount, parentBusiness: source}
                })

                /* Combine the array of newly fetched AdAccounts with the array of the previsously fetched AdAccounts */
                if ( newAdAccounts && newAdAccounts?.length > 0 ) {
                    metaHelper.adAccounts = [...metaHelper.adAccounts, ...newAdAccounts];
                }
                // metaHelper.adAccounts = [];
                // /* Check if we have selected ad accounts */
                // if ( reportSections.some((section) => section.sectionData && section.sectionData.some((sd) => sd.type === "adAccount")) ) { 
                //     remove_unselected_ad_accounts_from_selected(metaHelper, reportSections)
                // }
            } 
            break;
        }
        case ("adAccount"): {

            /* Assign selected business */
            metaHelper.selectedAdAccounts.push(source);
            setCreator((prev) => ({
                ...prev,
                metaHelper,
            }));

            // Check if we have already fetched campaigns for this ad account
            const oldCampaigns = creator.metaHelper.campaigns;
            if(!oldCampaigns?.some((campaign) => campaign.account_id === source.account_id)) {
                setCreator((prev) => ({
                    ...prev,
                    loaders: {
                        ...prev.loaders,
                        campaigns: false
                    }
                }));
    
                const campaignResponse = await get_campaigns(source.id, metaAccessToken);
    
                setCreator((prev) => ({
                    ...prev,
                    loaders: {
                        ...prev.loaders,
                        campaigns: true
                    }
                }));
    
    
                metaHelper.campaigns = [...oldCampaigns, ...campaignResponse?.data?.data?.myCampaigns];
            }

            const newReportSection = {
                type: "paid",
                sectionTitle: source.name,
                position: reportSections?.length,
                source: "meta",
                sectionData: [
                    {type: "adAccount", name: source.name, id: source.id},
                    {type: "facebookAccount", name: metaUsername, id: metaUserId, accessToken: metaAccessToken},
                ],
                rows: []
            }

            reportSections.push(newReportSection)
            break;
        }
    }

    setCreator((prev) => ({
        ...prev, 
        metaHelper,
        report: {
            ...prev.report, 
            sections: reportSections
        },
        // errors: !fetchedAdAccountsError ? prev.errors : {
        //     ...prev.errors,
        //     fetchAdAccounts: !fetchedAdAccountsError ? prev.errors.fetchAdAccounts : 
        //     [...prev.errors.fetchAdAccounts, { 
        //         extraInfo: {
        //             ...prev.errors.fetchAdAccounts.extraInfo,
        //             parentBusinessId: source.id
        //         },
        //         error: fetchedAdAccountsError ? fetchedAdAccountsError : false
        //     }],
        // },
        loaders: {
            ...prev.loaders,
            adAccounts: true,
        }
    }))
}

    // from is used to determine of we use this function from the initial wizard or from the regular Add_Section_Meta
    // we use different logic for each component
export const remove_source = (creator, setCreator, source, type, from, position) => {
    let metaHelper = JSON.parse(JSON.stringify(creator.metaHelper));
    let reportSections = JSON.parse(JSON.stringify(creator.report.sections));

    switch (type){
        case ("business"): {
            /* Assign selected business */
            metaHelper.selectedBusiness = null;
            metaHelper.selectedAdAccounts = [];
            break;
        }
        case ("adAccount"): {
            /* Assign selected business */
            metaHelper.selectedAdAccounts = [];

            const sectionToRemove = reportSections?.find((s) => s.position === position && s.sectionData.find((sd) => sd.type === "adAccount")?.id === source);
            // // if a campaign is included remove it from the campaign list as well.
            let indexOfFirstPipe = sectionToRemove.sectionTitle.indexOf('|');
            if(indexOfFirstPipe !== -1) {
                let campaignName = sectionToRemove.sectionTitle.substring(indexOfFirstPipe + 1).trim();

                let listOfCampaigns = creator.metaHelper.selectedCampaigns;

                listOfCampaigns = listOfCampaigns.filter((campaign) => campaign.name !== campaignName);
                metaHelper.selectedCampaigns = listOfCampaigns;
            }
            
            reportSections = reportSections?.filter((section) => 
                !(section.position === position && section.sectionData.find((sd) => sd.type == "adAccount")?.id === source));

            break;
        }
    }

    setCreator((prev) => ({
        ...prev, 
        metaHelper,
        report: {
            ...prev.report,
            sections: reportSections
        }
    }))
}



export const remove_unselected_ad_accounts_from_selected = (metaHelper, sections) => {
    let selectedAdAccounts = metaHelper?.adAccounts?.filter((adAccount) => 
        sections.some((section) => 
            section.sectionData && section.sectionData.find((sd) => sd.type === "adAccount")?.id === adAccount.id
        )
    )
    metaHelper.selectedAdAccounts = selectedAdAccounts

    return metaHelper
}

// Those 2 functions add and remove dynamically campaigns, so we change the title of the section based on the existance of a campaign
// add concats the title and remove sorters the title.
export const add_campaign = (creator, setCreator, campaign, sectionPosition) => {

    let metaHelper = deepClone(creator.metaHelper);
    // metaHelper.selectedCampaigns = [];
    metaHelper.selectedCampaigns.push(campaign);

    let datafilledStructure = creator.presetStructureHelper?.datafilledStructure 
        ? deepClone(creator.presetStructureHelper?.datafilledStructure)
        : deepClone(creator.presetStructure);

    let s = datafilledStructure.sections?.find((s) => s.position === sectionPosition && s.type === "paid");
    s.campaigns = metaHelper.selectedCampaigns;   
    setCreator((prev) => ({
        ...prev,
        metaHelper,
        presetStructureHelper: {
            ...prev.presetStructureHelper,
            datafilledStructure
        }
    }))
} 

export const remove_campaign = (creator, setCreator, campaign, sectionPosition) => {
    let metaHelper = JSON.parse(JSON.stringify(creator.metaHelper));

    metaHelper.selectedCampaigns = metaHelper.selectedCampaigns?.filter((obj) => obj.id !== campaign.id);


    let datafilledStructure = creator.presetStructureHelper?.datafilledStructure 
        ? deepClone(creator.presetStructureHelper?.datafilledStructure)
        : deepClone(creator.presetStructure);

    let s = datafilledStructure.sections?.find((s) => s.position === sectionPosition && s.type === "paid");


    s.campaigns = metaHelper.selectedCampaigns;   
    

    setCreator((prev) => ({
        ...prev,
        metaHelper,
        presetStructureHelper: {
            ...prev.presetStructureHelper,
            datafilledStructure
        }
    }))
}

export const add_campaign_to_section = (creator, setCreator, campaign, position) => {
    // find corresponding section of reports
    let reportSections = deepClone(creator.report.sections);

    let listOfCampaigns;
    let matchingSection = reportSections?.find((s) => s.position === position);
    if(matchingSection) { 
        listOfCampaigns = creator?.metaHelper?.selectedCampaigns;
        listOfCampaigns.push(campaign);
        matchingSection.campaigns = listOfCampaigns;
    }

    setCreator((prev) => ({ 
        ...prev,
        metaHelper: {
            ...prev.metaHelper,
            selectedCampaigns: matchingSection ? listOfCampaigns : creator.metaHelper.selectedCampaigns,
        },
        report: {
            ...prev.report,
            sections: reportSections,
        }
    }))
}

export const remove_campaign_from_section = (creator, setCreator, campaign, position) => {

    // trim name of section
    let reportSections = deepClone(creator.report.sections);
    let listOfCampaigns;

    let matchingSection = reportSections?.find((s) => s.position === position);
    if(matchingSection) {
        listOfCampaigns = creator?.metaHelper?.selectedCampaigns;
        listOfCampaigns = listOfCampaigns?.filter((c) => c?.id !== campaign?.id);
        matchingSection.campaigns = listOfCampaigns;
        
    }
    else {
        console.log("matching section not found for this campaign");
    }

    setCreator((prev) => ({ 
        ...prev,
        metaHelper: {
            ...prev.metaHelper,
            selectedCampaigns: matchingSection ? listOfCampaigns : creator.metaHelper.selectedCampaigns,
        },
        report: {
            ...prev.report,
            sections: reportSections,
        }
    }))
}